var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zqj0dcmdea)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.718 19.449H5.282a4.736 4.736 0 0 1-4.73-4.731V5.283A4.736 4.736 0 0 1 5.281.552h9.436a4.736 4.736 0 0 1 4.73 4.73v9.436a4.736 4.736 0 0 1-4.73 4.73zM5.282 1.336a3.951 3.951 0 0 0-3.946 3.946v9.436a3.95 3.95 0 0 0 3.946 3.946h9.436a3.95 3.95 0 0 0 3.946-3.946V5.283a3.95 3.95 0 0 0-3.946-3.947H5.282z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.832a4.832 4.832 0 1 1 0-9.664 4.832 4.832 0 0 1 0 9.664zm0-8.88a4.047 4.047 0 1 0 0 8.095 4.047 4.047 0 0 0 0-8.094zM15.007 5.939a1.407 1.407 0 1 1 0-2.814 1.407 1.407 0 0 1 0 2.814zm0-2.03a.622.622 0 1 0 0 1.245.622.622 0 0 0 0-1.244z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zqj0dcmdea"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.7a31e496f76bb63f31a39789f7de4bf9.svg";
export { ForwardRef as ReactComponent };